import { render, staticRenderFns } from "./ReadOnlyField.vue?vue&type=template&id=5249906d&scoped=true&"
import script from "./ReadOnlyField.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5249906d",
  null
  
)

export default component.exports